// eslint-disable-next-line no-restricted-imports
import { StudentCourseActivityFolderModel } from 'src/lib/services/api/students/classes/student-course.model';
// eslint-disable-next-line no-restricted-imports
import { hasValue } from '../compare';

const lmsEmbedPathSegment = '/local/gradally';

export enum RegistrationActivityAccessState {
	locked = 0,
	retry = 10,
	view_only = 15,
	open = 20,
}

export function getRegistrationActivityAccessState(
	activity: StudentCourseActivityFolderModel,
): RegistrationActivityAccessState {
	if (activity.locked) {
		return RegistrationActivityAccessState.locked;
	} else if (hasValue(activity.submitted_date)) {
		if (activity.allow_retry === false && activity.retry_implemented === true) {
			return RegistrationActivityAccessState.view_only;
		} else {
			return RegistrationActivityAccessState.retry;
		}
	} else {
		return RegistrationActivityAccessState.open;
	}
}

export function getCourseActivityType(
	activity: StudentCourseActivityFolderModel,
): [icon: string, title: string] {
	switch (activity.actual_type) {
		case 'lti':
			return ['fal fa-puzzle-piece', 'Quiz'];
		case 'quiz':
			return ['fal fa-ballot-check', 'Exam'];
		case 'url':
		case 'resource':
			return ['fal fa-book-open', 'Reading'];
		case 'assign':
			return ['fal fa-file-arrow-up', 'Assignment'];
		case 'forum':
			return ['fal fa-message-lines', 'Forum'];
		default:
			return ['fal fa-book-alt', 'Coursework'];
	}
}

/**
 * `embed_link` targets Moodle's `local/gradally` iframe wrapper, which only
 * renders inside the activity player. Drop it to link out to the activity.
 */
export function getCourseActivityLmsHref(
	activity: StudentCourseActivityFolderModel,
): string | null {
	const embedLink = activity?.embed_link?.trim();

	if (!embedLink) {
		return null;
	}

	try {
		const url = new URL(embedLink);

		// The LMS base URL can carry its own path, so the wrapper is not always
		// the leading segment.
		url.pathname = url.pathname.replace(`${lmsEmbedPathSegment}/`, '/');

		return url.toString();
	} catch {
		return embedLink.replace(`${lmsEmbedPathSegment}/`, '/');
	}
}
